import type { Editor } from "@tiptap/react"
import { pick } from "../../../filestack/api"
import { MEDIA_TYPES } from "../../../filestack/constants"
import type { PickerFileMetadata } from "../../../filestack/types"
import { createFilestackDownloadURL, getOptions } from "../../../filestack/utils"
import type { RichTextEditorPickedMedia } from "../../types"

export function insertAttachmentFromMedia(
  editor: Editor,
  file: RichTextEditorPickedMedia
) {
  const label = file?.filename || file?.name || "Attachment"
  const href = file?.downloadURL
    ? file.downloadURL
    : file?.handle
      ? createFilestackDownloadURL(file.handle, label)
      : file?.url
  if (!href) return

  editor
    .chain()
    .focus()
    .insertContent({
      type: "text",
      text: label,
      marks: [
        {
          type: "link",
          attrs: {
            href,
            target: "_blank",
            rel: "noopener noreferrer"
          }
        }
      ]
    })
    .insertContent(" ")
    .run()
}

export async function pickAndInsertAttachmentFromFilestack(
  editor: Editor,
  insert: (file: RichTextEditorPickedMedia) => void
) {
  try {
    const result = await pick(
      getOptions(MEDIA_TYPES.FILE, {
        maxFiles: 1
      })
    )

    ;(result.filesUploaded || []).forEach((file: PickerFileMetadata) => {
      insert(file)
    })
  } catch (error) {
    console.error("Error inserting file attachment from Filestack:", error)
  }
}
